export * from "./refHooks";
export { default as useLoadingValue } from "./useLoadingValue";

export type LoadingHook<T, E> =
  | [T | undefined, false, undefined]
  | [undefined, true, undefined]
  | [undefined, false, E];
